/**
 * Recursively checks whether all key-value pairs from the `subset` object
 * are included in the `obj` object. Supports deep nesting and array comparisons.
 *
 * For arrays, it verifies that every element in the `subset` array has a match
 * in the `obj` array based on deep equality (order does not matter).
 */

export const matchDeep = (obj: any, subset: any) => {
  if (!obj || !subset) return false
  if (typeof obj !== typeof subset) return false

  if (Array.isArray(subset)) {
    if (!Array.isArray(obj)) return false
    return subset.every((item) => obj.some((objItem) => matchDeep(objItem, item)))
  }

  if (typeof subset === 'object') {
    return Object.keys(subset).every((key) => key in obj && matchDeep(obj[key], subset[key]))
  }

  return obj === subset
}
